import {FC} from "react";
import ISvg from "../../interfaces/ISvg";

interface IClose extends ISvg {
    color?: string
}

const Close:FC<IClose> = ({className, color = "stroke-white"}) => {
    return <svg className={className} width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M27 2L2 27" className={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2 2L27 27" className={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

}

export default Close